import { defineStore } from "pinia"

export const useSnackBar = defineStore("snackbar", () => {
  const isShow = ref(false)
  const timeout = ref(2000)
  const location = ref("top")
  const color = ref("")
  const snackbarMessage = ref("")

  function showSnackBar  (pMessage, pColor="", pLocation="top", pTimeout=2000) {
    // 이미 표시 중이면 먼저 닫고 nextTick에서 다시 표시
    if (isShow.value) {
      isShow.value = false
      nextTick(() => {
        snackbarMessage.value = pMessage
        color.value = pColor
        location.value = pLocation
        timeout.value = pTimeout
        isShow.value = true
      })
    } else {
      snackbarMessage.value = pMessage
      color.value = pColor
      location.value = pLocation
      timeout.value = pTimeout
      isShow.value = true
    }
  }

  return { isShow, timeout, color, snackbarMessage, showSnackBar, location }
})
